import { getHeroBanners, getOurPartners, getPromotionPartners, getMockInquiry, getTestimonials } from "@/api/promotionMediaAPI"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getIPWithLocation } from "./countrySlice";
import { getIPAndLocation } from "@/api/dictionaryAPI";

export const fetchHeroBanners = createAsyncThunk("promotionMedia/getHeroBanners", async () => {
    return await getHeroBanners();
});

export const fetchOurPartners = createAsyncThunk("promotionMedia/getOurPartners", async () => {
    return await getOurPartners();
});

export const fetchPromotionPartners = createAsyncThunk("promotionMedia/getPromotionPartners", async () => {
    return await getPromotionPartners();
});

export const fetchMockInquiry = createAsyncThunk("promotionMedia/getMockInquiry", async () => {
    return await getMockInquiry();
});

export const fetchTestimonials = createAsyncThunk("promotionMedia/getTestimonials", async () => {
    return await getTestimonials();
});

// export const fetchHomePageData = createAsyncThunk("promotionMedia/fetchAll",
//     async (_, { dispatch }) => {
//         await Promise.all([
//             dispatch(getIPWithLocation()),
//             dispatch(fetchHeroBanners()),
//             dispatch(fetchOurPartners()),
//             dispatch(fetchPromotionPartners()),
//             dispatch(fetchMockInquiry()),
//             dispatch(fetchTestimonials()),
//         ]);
//     }
// );

export const fetchHomePageData = createAsyncThunk("promotionMedia/fetchAll",
    async (_, { dispatch }) => {
        const [
            ip,
            banners,
            partners,
            promotions,
            mockInquiry,
            testimonials
        ] = await Promise.all([
            getIPAndLocation(),
            getHeroBanners(),
            getOurPartners(20),
            getPromotionPartners(),
            getMockInquiry(),
            getTestimonials()
        ]);

        return {
            ip: ip,
            hero_banner: banners,
            partner_logos: partners,
            promotion_partner: promotions,
            mock_inquiry: mockInquiry,
            testimonials: testimonials
        };
    }
);



// const promotionMediaSlice = createSlice({
//     name: "promotionMedia",
//     initialState: {
//         hero_banner: [],
//         partner_logos: [],
//         promotion_partner: [],
//         mock_inquiry: [],
//         testimonail: [],
//         loading: false,
//         error: null
//     },
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(fetchHeroBanners.pending, (state) => { state.loading = true })
//             .addCase(fetchHeroBanners.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.hero_banner = action.payload
//             })
//             .addCase(fetchHeroBanners.rejected, (state) => {
//                 state.loading = false;
//                 state.hero_banner = [];
//                 state.error = "Something Went Wrong!";
//             })

//             .addCase(fetchOurPartners.pending, (state) => { state.loading = true })
//             .addCase(fetchOurPartners.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.partner_logos = action.payload
//             })
//             .addCase(fetchOurPartners.rejected, (state) => {
//                 state.loading = false;
//                 state.partner_logos = [];
//                 state.error = "Something Went Wrong!";
//             })

//             .addCase(fetchPromotionPartners.pending, (state) => { state.loading = true })
//             .addCase(fetchPromotionPartners.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.promotion_partner = action.payload
//             })
//             .addCase(fetchPromotionPartners.rejected, (state) => {
//                 state.loading = false;
//                 state.promotion_partner = [];
//                 state.error = "Something Went Wrong!";
//             })


//             .addCase(fetchMockInquiry.pending, (state) => { state.loading = true })
//             .addCase(fetchMockInquiry.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.mock_inquiry = action.payload
//             })
//             .addCase(fetchMockInquiry.rejected, (state) => {
//                 state.loading = false;
//                 state.mock_inquiry = [];
//                 state.error = "Something Went Wrong!";
//             })


//             .addCase(fetchTestimonials.pending, (state) => { state.loading = true })
//             .addCase(fetchTestimonials.fulfilled, (state, action) => {
//                 state.loading = false;
//                 state.testimonial = action.payload
//             })
//             .addCase(fetchTestimonials.rejected, (state) => {
//                 state.loading = false;
//                 state.testimonial = [];
//                 state.error = "Something Went Wrong!";
//             })

//     }
// });

const promotionMediaSlice = createSlice({
    name: "promotionMedia",
    initialState: {
        ip: null,
        hero_banner: [],
        partner_logos: [],
        promotion_partner: [],
        mock_inquiry: [],
        testimonials: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchHomePageData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchHomePageData.fulfilled, (state, action) => {
                state.loading = false;
                Object.assign(state, action.payload);
            })
            .addCase(fetchHomePageData.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default promotionMediaSlice.reducer;